import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyle = makeStyles(() => ({
  root: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontSize: "18px",
    fontWeight: 500,
  },
}));

export default function ScoringLoading({ classes, circularProps, ...props }) {
  const cls = useStyle();

  return (
    <Box className={clsx(cls.root, classes?.root)} {...props}>
      <CircularProgress {...circularProps} />
    </Box>
  );
}
